import { ReactComponent as SvgSearch } from '@img/icons/search-submit.svg';
import * as React from 'react';
import S from './SearchDropdown.styles';
const SearchDropdown = (props) => {
    const [value, setValue] = React.useState('');
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Backdrop, { onClick: props.onClose }),
        React.createElement(S.Container, null,
            React.createElement(S.Form, { action: props.searchResultsUrl, method: "get", onKeyDown: (event) => {
                    if (event.key === 'Escape') {
                        props.onClose();
                    }
                } },
                React.createElement(S.InputWrapper, null,
                    React.createElement(S.Input, { id: "header-search", autoFocus: true, name: "searchterm", placeholder: props.placeholder, type: "search", value: value, onChange: (event) => {
                            setValue(event.target.value);
                        } }),
                    React.createElement(S.Submit, { buttonType: "default", icon: React.createElement(SvgSearch, null), iconOnly: true, type: "submit" }, "Submit"))))));
};
export default SearchDropdown;
